class MTabs extends HTMLElement {
  constructor() {
    super();
    // Inicialización de propiedades directamente en el constructor para claridad
    this.tabs = this.querySelectorAll(".m-tabs__tab");
    this.contents = this.querySelectorAll('.m-tabs__content > div[role="tabpanel"]');
    this.contentContainer = this.querySelector(".m-tabs__content");
    this.currentIndex = this.determineInitialTabIndex(); // Determina el índice inicial aquí para centralizar la lógica

    // Añadir un contenedor para el contenido
    this.contentWrapper = document.createElement('div');
    this.contentWrapper.className = 'm-tabs__content-wrapper';
    this.contentContainer.parentNode.insertBefore(this.contentWrapper, this.contentContainer);
    this.contentWrapper.appendChild(this.contentContainer);

    this.setupTabs();
    this.adjustTranslateX(); // Ajusta el translateX basado en el índice inicial
    
    // Asegurar que la altura se calcule después de que todo esté cargado
    if (document.readyState === 'complete') {
      this.initializeHeight();
    } else {
      window.addEventListener('load', () => this.initializeHeight());
    }
    
    window.addEventListener("resize", () => {
      this.adjustTranslateX();
      this.adjustContentHeight();
    });
  }

  setupTabs() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener("click", (e) => {
        e.preventDefault();
        this.updateActiveTab(index); // Usa el índice para manejar el tab activo
      });
    });
  }

  adjustTranslateX() {
    const containerWidth = this.contentContainer.offsetWidth;
    const offset = this.currentIndex * -containerWidth;
    this.contentContainer.style.transform = `translateX(${offset}px)`;
  }

  updateActiveTab(selectedIndex) {
    this.currentIndex = selectedIndex; // Actualiza el índice actual

    // Actualiza la clase --tab-active y el atributo aria-selected para los tabs
    this.tabs.forEach((tab, index) => {
      const isActive = index === selectedIndex;
      tab.classList.toggle("--tab-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    // Actualiza la visibilidad de los paneles de contenido
    this.contents.forEach((content, index) => {
      const isContentActive = index === selectedIndex;
      content.classList.toggle("--is-active", isContentActive);
    });

    this.adjustTranslateX(); // Ajusta el translateX cada vez que se cambia de tab
    this.adjustContentHeight();
  }

  initializeHeight() {
    // Pequeño retraso para asegurar que las imágenes y otros recursos estén cargados
    setTimeout(() => {
      this.adjustContentHeight();
    }, 100);
  }

  adjustContentHeight() {
    const activeContent = this.contents[this.currentIndex];
    if (activeContent) {
      // Forzar un reflow para asegurar que el contenido esté renderizado
      void activeContent.offsetHeight;
      const height = activeContent.scrollHeight;
      this.contentWrapper.style.height = `${height}px`;
    }
  }

  determineInitialTabIndex() {
    // Encuentra el índice del tab que tiene la clase --is-active
    const activeTab = Array.from(this.contents).find(tab => tab.classList.contains("--is-active"));
    console.log(activeTab);
    return Math.max(Array.from(this.contents).indexOf(activeTab), 0); // Usa Math.max para asegurar un mínimo de 0
  }
}

customElements.define("m-tabs", MTabs);
